import { isNull } from 'lodash-es'

import {
  AccountUpdate,
  useAccountValidation,
  useGuestDepositReturnAccount,
} from '@/features/update-account'
import { formatDateWithDayOfWeek } from '@/shared/lib'

type Props = {
  contractId: number
}

export const DepositReturnAccount = ({ contractId }: Props) => {
  const { depositReturnAccount, hasDepositReturnAccount } =
    useGuestDepositReturnAccount({ contractId })

  const { handleAccountFormOpen } = useAccountValidation()

  const isEditable = depositReturnAccount?.isEditAvailable ?? true

  const isDepositReturned =
    depositReturnAccount?.isDepositReturned &&
    !isNull(depositReturnAccount?.depositReturnedAt)

  return (
    <div className="space-y-3">
      <h3 className="typo-body1 font-semibold text-black">보증금 반환 계좌</h3>

      <div className="space-y-2">
        {(() => {
          if (isEditable) {
            return (
              <AccountUpdate
                defaultFormOpen={!hasDepositReturnAccount(depositReturnAccount)}
                hasDefaultAccount={hasDepositReturnAccount(
                  depositReturnAccount,
                )}
                description="퇴실 완료 후 보증금을 수령할 계좌를 입력해 주세요"
                onFormOpen={handleAccountFormOpen}
              />
            )
          }

          const displayAccount = hasDepositReturnAccount(depositReturnAccount)
            ? `${depositReturnAccount.depositReturnBankName} ${depositReturnAccount.depositReturnBankAccount} (${depositReturnAccount.depositReturnBankHolder})`
            : '계좌 정보 없음'

          return (
            <>
              <p className="typo-label1 font-medium text-gray-900">
                {displayAccount}
              </p>
              {isDepositReturned && (
                <p className="typo-body1 font-bold text-purple-500">
                  {formatDateWithDayOfWeek({
                    date: depositReturnAccount.depositReturnedAt!,
                  })}{' '}
                  반환 완료
                </p>
              )}
            </>
          )
        })()}
      </div>
    </div>
  )
}
